
import React, { Component } from 'react';
import './App.css';
import Header from './views/Header';
import Footer from './views/Footer';
import Home from './views/Home';
import Login from './views/Login';
import Private from './views/Private';
import SubmitPage from './views/SubmitPage';
import ReviewPage from './views/ReviewPage';

import ReviewIdeaPage from "./views/ReviewIdeaPage";
import DelegatePage from "./views/DelegatePage";
import UpdateIdeaPage from "./views/UpdateIdeaPage";
import ViewIdeaPage from "./views/ViewIdeaPage";
import EditIdeaPage from './views/EditIdeaPage';
import MBBReviewIdeaPage from './views/MBBReviewIdeaPage';
import { OKTA_BASE_URL, OKTA_CLIENT_ID, OKTA_REDIRECT_URL, USER_DATA, PROD_MODE, ACCESS_TOKEN, GET_METADATA } from './assets/constants/constants';
import FinalReviewIdeaPage from "./views/FinalReviewIdeaPage";
import { Route } from 'react-router-dom';
import { LoginCallback, SecureRoute, Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { useHistory } from 'react-router-dom';
import { ProjectListPage } from './views/ProjectListPage';
import { BbMonetizationApproval } from './views/BbMonetizationApproval';
import { MbbMonetizationApproval } from './views/MbbMonetizationApproval';

// 11-09-2025 user link story inserting a single line jus to update the branch later needs to be deleted

import ValueDelivery from './utils/ValueDelivery';
import ViewProjectPage from './views/ViewProjectPage';
import ViewAllIdeaPage from './views/ViewAllIdeaPage';
import ViewAllProjectsPage from './views/ViewAllProjectsPage';

// import PrivateRoutes from "./views/PrivateRoutes";
import UpdatedSpeech from './views/UpdatedSpeech';
import SpeechSubmitPage from './views/SpeechToTextSubmitPage'
import ProjectReviewGroup from './views/ProjectReviewGroup'
import AuditorReview from './views/AuditerReview'
import MyQCReview from './views/MyQcReview';
import AdminDataEdit from './views/AdminDataEdit';
import QCMonetizationApproval from './views/QCMonetizationApproval';
import ShowTree from './utils/ShowTree';
import Hirearchy from './utils/Hirearchy';
import RenewToken from './utils/RenewToken'


import ProductivityOwnerListPage from './views/ProductivityOwnerListPage'
import ProductivityMentorListPage from './views/ProductivityMentorListPage'
import ProductivityDetailsPage from './views/ProductivityDetailsPage'
import ProductivityAdminListPage from './views/ProductivityAdminListPage';
import ProductivityAdminDetailPage from './views/ProductivityAdminDetailPage';

const oktaAuth = new OktaAuth({
  issuer: `${OKTA_BASE_URL}`,
  clientId: `${OKTA_CLIENT_ID}`,
  redirectUri: `${OKTA_REDIRECT_URL}`
  
});

const HostName = window.location.hostname.trim();
console.log(HostName)
const userData = JSON.parse(localStorage.getItem(USER_DATA))
if (userData) {
  if (HostName === "xceleratedev.genpact.com") {
    if (userData.profile.oHRId === "800100766"  ||  userData.profile.oHRId === "850065233" || userData.profile.oHRId === "850075058" || 
      userData.profile.oHRId === "850074422" || userData.profile.oHRId === "850075361" ||userData.profile.oHRId === "850051499" || 
      userData.profile.oHRId === "703337474" || userData.profile.oHRId === "850076800"  || 
      userData.profile.oHRId === "703399147" || userData.profile.oHRId ==="850080176" || userData.profile.oHRId === "850082025" ||
      userData.profile.oHRId === "703023099" || userData.profile.oHRId === "703154746" || userData.profile.oHRId === "703107741" ||
      userData.profile.oHRId === "850077071" || userData.profile.oHRId === "703377935" || userData.profile.oHRId === "850081036" || 
      userData.profile.oHRId === "850080667"
    ) {
      console.log("Permitted only for developers")
    } else {
      window.location.replace('https://xcelerateuat.genpact.com');
    }
  }
}


const App = (props) => {

  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };
  const onAuthRequired = function () {
    history.push('/login')
  }
  return (
    <div className="App">
      <div className="page">
        <div className="content">
          <Security oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
            onAuthRequired={onAuthRequired}>
            <Header />
            <RenewToken />
            <Route path='/' exact={true} component={Home} />
            <Route path='/login' exact={true} component={Login} />
            <Route path='/home' component={Home} />
            <SecureRoute path="/submit-page" component={SubmitPage} />
            <SecureRoute path="/review-page" render={props => <ReviewPage {...props} />} />
            <Route path="/review-idea-page" render={props => <ReviewIdeaPage {...props} />} />
            <Route path="/delegate-page" render={props => <DelegatePage {...props} />} />
            <Route path="/update-idea-page" render={props => <UpdateIdeaPage {...props} />} />
            <Route path="/view-idea-page" render={props => <ViewIdeaPage {...props} />} />
            <Route path="/edit-idea-page" render={props => <EditIdeaPage {...props} />} />
            <Route path="/final-review-idea-page" render={props => <FinalReviewIdeaPage {...props} />} />
            <Route path="/mbb-review-idea-page" render={props => <MBBReviewIdeaPage {...props} />} />
            <Route path="/list-projects-page" render={props => <ProjectListPage {...props} />} />
            <Route path="/view-project-page" render={props => <ViewProjectPage {...props} />} />
            <Route path="/view-all-ideas-page" render={props => <ViewAllIdeaPage {...props} />} />
            <Route path="/view-all-projects-page" render={props => <ViewAllProjectsPage {...props} />} />
         
            <Route path="/updated" render={props => <UpdatedSpeech {...props} />} />
            <Route path="/speech-submit-page" render={props => <SpeechSubmitPage {...props} />} />
            
            <Route path="/project-review-group-page" render={props => <ProjectReviewGroup {...props} />} />
            <Route path="/auditor-review-page" render={props => <AuditorReview {...props} />} />
            <Route path="/my-qc-reviews-page" render={props => <MyQCReview {...props} />} />
            <Route path="/bb-monetization-approval-page" render={props => <BbMonetizationApproval {...props} />} />
            <Route path="/mbb-monetization-approval-page" render={props => <MbbMonetizationApproval {...props} />} />

            
            <SecureRoute exact path="/ideationhome" render={() => { window.location.href = "idea/index.html" }} />
            <SecureRoute path='/private' exact={true} component={Private} />
            <Route path='/callback' component={LoginCallback} />
            <Route path='/valueDelivery' component={ValueDelivery} />
            <Route path='/admin-data-edit' component={AdminDataEdit} />
            <Route path='/qc-monetization-approval-page' component={QCMonetizationApproval} />
            <Route path='/showTree' component={ShowTree} />
            <Route path='/hierarchy' component={Hirearchy} />


            <Route path="/productivity-owner-list-page" render={props => <ProductivityOwnerListPage {...props} />} />
            <Route path="/productivity-mentor-list-page" render={props => <ProductivityMentorListPage {...props} />} />
            <Route path="/productivity-details-page" render={props => <ProductivityDetailsPage {...props} />} />

            <Route path="/productivity-admin-list-page" render={props => <ProductivityAdminListPage {...props} />} />
            <Route path="/productivity-admin-details-page" render={props => <ProductivityAdminDetailPage {...props} />} />
            
            <div style={{ paddingTop: 30 }}>&nbsp;</div>
            <Footer />
          </Security>
          {/* <br /><br /><br />
          <label>Please use 'SIGN IN' or 'Login' link above to logon to Ideation Home Page.</label> */}
        </div>
      </div>
    </div>
  );
}

export default App;
